import React from "react";
import { FiBell, FiClock, FiChevronRight } from "react-icons/fi";

function NotificationCard({ notification }) {
  // Convert Firebase timestamp to date
  const date = notification.dateTime?.toDate().toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className="bg-white rounded-lg border border-gray-100 hover:border-[#8FCD00] transition-all duration-200 overflow-hidden text-xs group">
      <div className="p-3.5">
        <div className="flex items-start gap-3">
          {/* Icon */}
          <div className="flex-shrink-0">
            <div
              className={`w-9 h-9 rounded-lg flex items-center justify-center transition-colors duration-200 ${
                notification.read ? "bg-gray-50" : "bg-[#363062] bg-opacity-10"
              }`}
            >
              <FiBell
                className={`w-4 h-4 ${
                  notification.read ? "text-gray-400" : "text-[#363062]"
                }`}
              />
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between mb-1">
              <h3 className="text-sm font-medium text-[#363062] line-clamp-1 group-hover:text-[#8FCD00] transition-colors duration-200">
                {notification.subject}
              </h3>
              {!notification.read && (
                <span className="ml-2 px-2 py-0.5 text-[10px] font-medium text-[#363062] bg-[#363062] bg-opacity-10 rounded-full">
                  New
                </span>
              )}
            </div>

            <p className="text-xs text-gray-600 line-clamp-2 mb-2 leading-relaxed">
              {notification.message}
            </p>

            <div className="flex items-center justify-between text-[10px]">
              <div className="flex items-center text-gray-400 gap-1">
                <FiClock className="w-3 h-3" />
                <span>{date}</span>
              </div>
              <div className="flex items-center text-[#8FCD00] font-medium group-hover:translate-x-0.5 transition-transform duration-200">
                <span>View details</span>
                <FiChevronRight className="w-3 h-3 ml-0.5" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotificationCard;